<template lang="pug">

div

    //- Navigation
    navigation

    //- Datenbank
    .ui.top.attached.header
        .content Datenbanken
    .ui.bottom.attached.segment
        .ui.info.message
            i.info.circle.icon
            | Nach einem Reset (Drop) muss der betroffene Service neu gestartet werden, damit das Datenbank-Schema wieder angelegt wird.

        .ui.form
            .field
                select.ui.selection.dropdown(ref='databaseDropdown')
                    option(v-for='db in databases' v-bind:key='db.key' v-bind:value='db.key') {{ db.label }}

    .ui.buttons
        button.ui.labeled.icon.button(v-on:click='exportDatabase' v-bind:disabled='databaseBusy')
            i.download.icon
            | Backup (Export)
        label.ui.labeled.icon.button(v-bind:class='{ disabled: databaseBusy }')
            i.upload.icon
            | Restore (Import)
            input(type='file' accept='.sql' v-on:change='restoreDatabase' v-bind:disabled='databaseBusy' style='display: none')
        button.ui.negative.labeled.icon.button(v-on:click='dropDatabase' v-bind:disabled='databaseBusy')
            i.trash.icon
            | Reset (Drop)

</template>

<script>
    import store from '@/store'
    import { DATABASES } from '@/utils/databases'
    import Navigation from '@/components/settings/Navigation.vue'

    export default {
        name: 'settings',

        components: { Navigation },

        data() {
            return {
                selectedDatabase: 'zmuek_companies',
                databaseBusy: false,
            }
        },

        computed: {

            databases() {
                return DATABASES
            },

        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        methods: {

            _initDropdown() {
                const el = this.$refs.databaseDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        this.selectedDatabase = value
                    }
                })
            },

            async exportDatabase() {
                this.databaseBusy = true
                try {
                    const blob = await store.dispatch('settings/exportDatabase', this.selectedDatabase)
                    const url = URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = this.selectedDatabase + '.sql'
                    link.click()
                    URL.revokeObjectURL(url)
                    this.$growl.success('Backup wurde erstellt')
                } catch (e) {
                    this.$growl.error('Backup fehlgeschlagen')
                } finally {
                    this.databaseBusy = false
                }
            },

            async dropDatabase() {
                const confirmed = await this.$growl.confirm(
                    'Datenbank "' + this.selectedDatabase + '" wirklich löschen und zurücksetzen?'
                )
                if (!confirmed) return

                this.databaseBusy = true
                try {
                    await store.dispatch('settings/dropDatabase', this.selectedDatabase)
                    this.$growl.success('Datenbank wurde zurückgesetzt')
                } catch (e) {
                    this.$growl.error('Reset fehlgeschlagen')
                } finally {
                    this.databaseBusy = false
                }
            },

            async restoreDatabase(event) {
                const file = event.target.files && event.target.files[0]
                if (!file) return

                const confirmed = await this.$growl.confirm(
                    'Datenbank "' + this.selectedDatabase + '" aus "' + file.name + '" wiederherstellen?'
                )
                if (!confirmed) return

                this.databaseBusy = true
                try {
                    await store.dispatch('settings/restoreDatabase', { database: this.selectedDatabase, file })
                    this.$growl.success('Datenbank wurde wiederhergestellt')
                } catch (e) {
                    this.$growl.error('Wiederherstellung fehlgeschlagen')
                } finally {
                    this.databaseBusy = false
                    event.target.value = ''
                }
            },

        },

    }

</script>
